import { Sms, User } from "iconsax-react";
import InputField from "../../components/inputs/InputField";
import PasswordField from "../../components/inputs/PasswordField";
import { Link, redirect, useNavigate } from "react-router-dom";
import AuthButton from "../../components/buttons/AuthButton";
import { useState } from "react";
import instance from "../../axios/instance";
import { saveToken } from "../../utils/token";

export default function ForgotPasswordPage() {
  // form state
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(false);

  // loading state
  const [isLoading, setIsLoading] = useState(false);

  // error message state
  const [errorMessage, setErrorMessage] = useState("");

  const isButtonNotActive = !email;

  function loginDoctor() {
    setErrorMessage("");
    setIsLoading(true);

    instance
      .post("/doctor/auth/forgot-password", { email })
      .then((response) => {
        setSuccess(true)
        setIsLoading(false);
      })
      .catch((error) => {
        setErrorMessage(error.response.data.message);
        setIsLoading(false);
      });
  }
  return (
    <div className="h-[100vh] bg-[#f1f1f1] flex flex-col justify-center items-center text-[14px]">
      <div className="bg-white flex flex-col justify-center items-center py-12 px-10 shadow-lg rounded-[10px]">
        <img src="/images/logo1.png" className="w-48 mb-2" />

        <div className="text-gray-500">Retrieve your password</div>

      {success ? (
        <span className="block mt-8 text-sm">A link has been sent to your email. Click on it to change your password</span>
      ) : (
        <form onSubmit={loginDoctor} className="mt-8 space-y-4 flex flex-col">
          <InputField
            icon={<Sms size={16} variant="Bold" />}
            type="email"
            placeholder="Enter email"
            onChange={(e) => setEmail(e.target.value)}
          />

          <AuthButton
            title="Send"
            disabled={isButtonNotActive || isLoading}
            isLoading={isLoading}
            type="submit"
            onClick={loginDoctor}
          />

          <div className="font-semibold text-red-500">{errorMessage}</div>
        </form>
      )}
      </div>
    </div>
  );
}
